/**
 * 処分業者
 */
 import Vue from 'vue'
 import * as httpConst from '../../../constants/httpConst'
 import * as types from '../../mutation-types/driver-types'
import {DRIVER_DISPOSAL_FLOW_RESET_CONDITION} from "../../mutation-types/driver-types";

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/disposal_flows`

const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      search_type: null,
      specify_type: 'range',
      start_no: null,
      end_no: null,
      no_1: null,
      no_2: null,
      no_3: null,
      no_4: null,
      no_5: null,
      start_date: null,
      end_date: null,
      emission_id: null,
      item_id: null,
      expired: false,
      neared: false,
      canceled: false,
    },
  }
}


 const disposal_flow = {

  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * マニフェスト管理取得
     * @param dispatch
     * @param commit
     * @param state
     * @param conditions { Object }
     * @param page { Number }
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { conditions, page }) {
      dispatch('saveCondition', { conditions: conditions })
      const params = {
        search_type: state.condition.search_type,
        specify_type: state.condition.specify_type,
        start_no: state.condition.start_no,
        end_no: state.condition.end_no,
        no_1: state.condition.no_1,
        no_2: state.condition.no_2,
        no_3: state.condition.no_3,
        no_4: state.condition.no_4,
        no_5: state.condition.no_5,
        start_date: state.condition.start_date,
        end_date: state.condition.end_date,
        emission_id: state.condition.emission_id,
        item_id: state.condition.item_id,
        expired: state.condition.expired,
        neared: state.condition.neared,
        canceled: state.condition.canceled,
        page: page,
      }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.DRIVER_DISPOSAL_FLOW, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    saveCondition ({ commit, state }, { conditions }) {
      const _search_type = ( conditions.searchType !== undefined ) ? conditions.searchType : state.condition.search_type
      const _specify_type = ( conditions.specifyType !== undefined ) ? conditions.specifyType : state.condition.specify_type
      const _manifest_start_no = ( conditions.startNo !== undefined ) ? conditions.startNo : state.condition.start_no
      const _manifest_end_no = ( conditions.endNo !== undefined ) ? conditions.endNo : state.condition.end_no
      const _manifest_no_1 = ( conditions.no_1 !== undefined ) ? conditions.no_1: state.condition.no_1
      const _manifest_no_2 = ( conditions.no_2 !== undefined ) ? conditions.no_2: state.condition.no_2
      const _manifest_no_3 = ( conditions.no_3 !== undefined ) ? conditions.no_3: state.condition.no_3
      const _manifest_no_4 = ( conditions.no_4 !== undefined ) ? conditions.no_4: state.condition.no_4
      const _manifest_no_5 = ( conditions.no_5 !== undefined ) ? conditions.no_5: state.condition.no_5
      const _collected_start_date = ( conditions.startDate !== undefined ) ? conditions.startDate: state.condition.start_date
      const _collected_end_date = ( conditions.endDate !== undefined ) ? conditions.endDate : state.condition.end_date
      const _emission_id = ( conditions.emissionId !== undefined ) ? conditions.emissionId : state.condition.emission_id
      const _item_id = ( conditions.itemId !== undefined ) ? conditions.itemId : state.condition.item_id
      const _only_expired = ( conditions.expired !== undefined ) ? conditions.expired : state.condition.expired
      const _only_neared = ( conditions.neared !== undefined ) ? conditions.neared : state.condition.neared
      const _only_canceled = (conditions.canceled !== undefined) ? conditions.canceled : state.condition.canceled
      const params = {
        search_type: _search_type,
        specify_type: _specify_type,
        start_no: _manifest_start_no,
        end_no: _manifest_end_no,
        no_1: _manifest_no_1,
        no_2: _manifest_no_2,
        no_3: _manifest_no_3,
        no_4: _manifest_no_4,
        no_5: _manifest_no_5,
        start_date: _collected_start_date,
        end_date: _collected_end_date,
        emission_id: _emission_id,
        item_id: _item_id,
        expired: _only_expired,
        neared: _only_neared,
        canceled: _only_canceled
      }
      commit(types.DRIVER_DISPOSAL_FLOW_CONDITION, { params })
    },
      resetState ({ commit }) {
        commit(types.DRIVER_DISPOSAL_FLOW_RESET_CONDITION)
      },
  },
  mutations: {
    [types.DRIVER_DISPOSAL_FLOW_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.DRIVER_DISPOSAL_FLOW] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.DRIVER_DISPOSAL_FLOW_CONDITION] (state, { params }) {
      state.condition.search_type = params.search_type
      state.condition.specify_type = params.specify_type
      state.condition.start_no = params.start_no
      state.condition.end_no = params.end_no
      state.condition.no_1 = params.no_1
      state.condition.no_2 = params.no_2
      state.condition.no_3 = params.no_3
      state.condition.no_4 = params.no_4
      state.condition.no_5 = params.no_5
      state.condition.start_date = params.start_date
      state.condition.end_date = params.end_date
      state.condition.emission_id = params.emission_id
      state.condition.item_id = params.item_id
      state.condition.expired = params.expired
      state.condition.neared = params.neared
      state.condition.canceled = params.canceled
    }
  },

 }

 export default disposal_flow
